/**
 * @generated SignedSource<<a58a6c930736bb537fd1c0670424cbd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignFilterScreenQuery$variables = {};
export type CampaignFilterScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CampaignFilter">;
};
export type CampaignFilterScreenQuery = {
  response: CampaignFilterScreenQuery$data;
  variables: CampaignFilterScreenQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignFilterScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CampaignFilter"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CampaignFilterScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MCategory",
        "kind": "LinkedField",
        "name": "mCategories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "keyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "64a322f2db15df1622e96b5d4d142ac3",
    "id": null,
    "metadata": {},
    "name": "CampaignFilterScreenQuery",
    "operationKind": "query",
    "text": "query CampaignFilterScreenQuery {\n  ...CampaignFilter\n}\n\nfragment CampaignFilter on Query {\n  mCategories {\n    id\n    name\n    keyName\n  }\n}\n"
  }
};

(node as any).hash = "a165eeb0f6274043524f4d0aa760020e";

export default node;
